import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withStyles } from "tss-react/mui";
import { CircularProgress, FormLabel, Tooltip } from "@mui/material";
import { Add, Close, Delete } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";
import TimeSlot from "../../../components/TimeTable/TimeSlot";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import * as actions from "../../../store/actions";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

//###
import axios from "axios";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import SaveButton from "../../../components/CustomInput/SaveButton";
import { __ } from "../../../translations/utils";
import { toast } from "react-toastify";
import { differenceInDays, format, parse } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

function TimeoddsModal({ ...props }) {
  const { classes } = props;
  const [loading, setLoading] = useState(true);
  const [timeOdds, setTimeOdds] = useState([]);
  const [renderEmptySlotRow, setRenderEmptySlotRow] = useState(false);
  const [saving, setSaving] = useState(false);
  const [newDate, setNewDate] = useState(null);

  let refreshKey = Math.ceil(Math.random() * 100);

  const regenerateRefreshKey = () => {
    refreshKey = Math.ceil(Math.random() * 100);
  };

  /**
   * Component did mount
   */
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setTimeOdds([]);
    setLoading(true);

    let searchData = [{ field: "type", operator: "=", value: props.type }];

    axios
      .post("/core/timeodds/search?sort_field=date&sort_dir=asc&vestiging_id=" + props.vestiging_id, searchData)
      .then((response) => {
        setTimeOdds(response.data.data.data);
        setLoading(false);
      });
  };

  const handleTimeSettingsChange = (arrPlace, action, data = null) => {
    let arrPlaces = arrPlace.split(",");

    let newTimeOdds = [...timeOdds];

    /**
     * ADD NIEUW TIMESLOT
     */
    if (action === "ADD") {
      if (newTimeOdds[arrPlaces[0]].scheme === null) {
        newTimeOdds[arrPlaces[0]].scheme = [];
      }

      newTimeOdds[arrPlaces[0]].scheme.push(data);
    }

    /**
     * UPDATE A TIMESLOT
     */
    if (action === "UPDATE") {
      newTimeOdds[arrPlaces[0]].scheme[arrPlaces[1]] = data;
    }

    /**
     * DELETE A TIME SLOT
     */
    if (action === "DELETE") {
      newTimeOdds[arrPlaces[0]].scheme.splice(arrPlaces[1], 1);
      if (newTimeOdds[arrPlaces[0]].scheme.length === 0) {
        newTimeOdds[arrPlaces[0]].scheme = null;
      }
    }

    newTimeOdds[arrPlaces[0]].needsSave = true;

    setTimeOdds(newTimeOdds);
  };

  const addNewItem = (date) => {
    let oldTimeOdds = [...timeOdds];

    let newItem = {
      id: null,
      vestiging_id: props.vestiging_id,
      date: format(date, "yyyy-MM-dd"),
      type: props.type,
      scheme: null,
      needsSave: true,
    };

    oldTimeOdds.push(newItem);

    oldTimeOdds.sort(function (a, b) {
      return differenceInDays(parse(a.date, "yyyy-MM-dd", new Date()), parse(b.date, "yyyy-MM-dd", new Date()));
    });

    setTimeOdds(oldTimeOdds);
    setNewDate(null);
  };

  const removeItem = (row) => {
    let oldTimeOdds = [...timeOdds];
    oldTimeOdds[row].needsSave = true;
    oldTimeOdds[row].deleted = true;

    setTimeOdds(oldTimeOdds);
  };

  const save = () => {
    setSaving(true);
    let data = timeOdds.filter((timeOdd) => {
      return timeOdd.needsSave;
    });

    axios.post("/core/timeodds/savetimeodds", data).then((response) => {
      setSaving(false);
      getData();
      if (response.data.data.success) {
        toast.success(response.data.data.message);
      } else {
        toast.error(response.data.data.message);
      }
    });
  };

  const changedItems = timeOdds.filter((timeOdd) => {
    return timeOdd.needsSave !== undefined && timeOdd.needsSave;
  }).length;

  return (
    <div>
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={props.toggle}
        open={props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"Tijdschema uitzonderingen maken."} tKey={"timeoddsmodal.header"} />
          </h4>
        </DialogTitle>
        <DialogContent
          className={classes.modalBody}
          id={"notice-modal-slide-description"}
          style={{ minHeight: "300px" }}
        >
          {loading ? (
            <div className={classes.loadingMain}>
              <CircularProgress className={classes.loadingIcon} />
            </div>
          ) : null}

          {!loading ? (
            <GridContainer>
              <GridItem>
                <DatePicker closeOnSelect onChange={(date) => setNewDate(date)} value={newDate} />
              </GridItem>
              <GridItem>
                <Button
                  color={"success"}
                  disabled={newDate === null}
                  onClick={() => {
                    addNewItem(newDate);
                  }}
                >
                  Nieuwe uitzondering toevoegen
                </Button>
              </GridItem>
            </GridContainer>
          ) : null}

          {!loading
            ? timeOdds.map((timeOdd, rowKey) => {
                /**
                 * Als deleted niet renderen wel nodig bij opslaan
                 */
                if (timeOdd.deleted === true) {
                  return null;
                }

                return (
                  <GridContainer key={rowKey + refreshKey}>
                    <GridItem lg={2} xs={12}>
                      <FormLabel className={classes.labelHorizontal}>
                        {format(parse(timeOdd.date, "yyyy-MM-dd", new Date()), "dd-MM-yyyy")}
                      </FormLabel>
                    </GridItem>
                    <GridItem>
                      {timeOdd.scheme !== null ? (
                        timeOdd.scheme.map((timeslot, key) => {
                          return (
                            <TimeSlot
                              arrPlace={rowKey + "," + key}
                              forceRefresh={regenerateRefreshKey}
                              handleTimeSettings={handleTimeSettingsChange}
                              key={key + refreshKey}
                              maxItems={timeslot["maxItems"] !== undefined ? timeslot["maxItems"] : 0}
                              showMaxItems={props.type === 2}
                              startTimeOrg={timeslot["startTime"]}
                              stopTimeOrg={timeslot["stopTime"]}
                              toggleEmptySlots={() => {
                                setRenderEmptySlotRow(rowKey);
                              }}
                            />
                          );
                        })
                      ) : (
                        <TranslationWrapper tDefault={"Gesloten"} tKey={"timeoddsmodal.closed"} />
                      )}
                    </GridItem>
                    <GridItem>
                      {rowKey === renderEmptySlotRow ? (
                        <TimeSlot
                          arrPlace={rowKey + ",9999"}
                          editing
                          handleTimeSettings={handleTimeSettingsChange}
                          isNewSlot
                          key={rowKey + "empty" + refreshKey}
                          maxItems={0}
                          showMaxItems={props.type === 2}
                          startTimeOrg={"00:00"}
                          stopTimeOrg={"00:00"}
                          toggleEmptySlots={() => {
                            setRenderEmptySlotRow(false);
                          }}
                        />
                      ) : (
                        <Tooltip
                          classes={{ tooltip: classes.tooltip }}
                          placement={"bottom"}
                          title={<TranslationWrapper tDefault={"Toevoegen"} tKey={"global.tooltip.toevoegen"} />}
                        >
                          <Button
                            className={classes.actionButton}
                            color={"success"}
                            onClick={() => setRenderEmptySlotRow(rowKey)}
                            simple
                          >
                            <Add className={classes.icon} />
                          </Button>
                        </Tooltip>
                      )}
                      <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        placement={"bottom"}
                        title={<TranslationWrapper tDefault={"Verwijderen"} tKey={"global.tooltip.remove"} />}
                      >
                        <Button
                          className={classes.actionButton}
                          color={"danger"}
                          onClick={() => removeItem(rowKey)}
                          simple
                        >
                          <Delete className={classes.icon} />
                        </Button>
                      </Tooltip>
                    </GridItem>
                  </GridContainer>
                );
              })
            : null}
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={__("timeodds", "modal.timeodds.button.save", "Aanpassingen opslaan")}
            disabled={changedItems === 0}
            key={"savebutton"}
            onClick={save}
            saving={saving}
            type={"button"}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    userLocale: state.user.lang,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) =>
      dispatch({
        type: actions.SHOW_MESSAGE,
        message: message,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TimeoddsModal, notificationsStyle));
